import React, { Fragment, useCallback, useEffect, useState } from "react";

import Typography from "../atoms/Typography/Typography";
import Modal from "../molecules/Modal/Modal";

const withErrorModal = (WrappedComponent) => (props) => {
  const { error } = props;
  const [showErr, setshowErr] = useState(false);

  useEffect(() => {
    if (error) {
      console.log("Error Message: ", error);
      setshowErr(true);
    }
  }, [error]);

  const closeModalHandler = useCallback(() => {
    setshowErr(false);
    window.location.reload();
  }, []);

  const hasError = !!showErr;

  const modal = hasError && (
    <Modal show={hasError} modalClosed={closeModalHandler}>
      <Typography type="h3">An unexpected error happen!</Typography>
      <Typography>
        Click to refresh the page, if the error persists please wait in few
        minutes.
      </Typography>
    </Modal>
  );

  return (
    <Fragment>
      {modal}
      <WrappedComponent {...props} />
    </Fragment>
  );
};

export default withErrorModal;
